var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollMarker",staticClass:"scroll-marker",style:({ '--scroll-y': _vm.scrollY + 'px' })},[(_vm.bottomCircle)?_c('div',{staticClass:"bottom-circle"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }